import clsx from 'clsx'
import React, { forwardRef } from 'react'

interface CheckboxInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  indeterminate?: boolean;
}

export const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ indeterminate, ...props }, forwardedRef) => {
    const selectorClassName = clsx(
      'w-4 h-4',
      'flex items-center justify-center',
      'border border-gray-400 peer-checked:border-thatch-300 peer-indeterminate:border-thatch-300 peer-disabled:border-gray-400 peer-aria-invalid:border-red-400 rounded-[0.25rem]',
      'bg-white peer-checked:bg-thatch-500 peer-indeterminate:bg-thatch-500 peer-disabled:bg-gray-200',
      'text-transparent peer-checked:text-white peer-indeterminate:text-white peer-disabled:text-gray-200 peer-disabled:peer-checked:text-gray-400 peer-disabled:peer-indeterminate:text-gray-400',
      'outline outline-offset-2 outline-2 outline-transparent peer-focus-visible:outline-thatch-500 group-[]/checkbox-container:peer-focus-visible:outline-transparent',
      'transition'
    )

    return (
      <div className='relative rounded-lg shadow-[0_0_0_0rem] has-[:hover]:shadow-[0_0_0_0.5rem] group-hover/checkbox-container:shadow-[0_0_0_0.5rem] shadow-transparent has-[:hover]:shadow-gray-800/5 group-hover/checkbox-container:shadow-gray-800/5 has-[:disabled]:has-[:hover]:shadow-transparent transition'>
        <input
          {...props}
          className='appearance-none absolute left-0 top-0 w-4 h-4 opacity-0 peer cursor-pointer disabled:cursor-default'
          ref={forwardedRef}
          type='checkbox'
        />
        <div className={selectorClassName}>
          {indeterminate
            ? (
              <svg
                aria-hidden
                className='w-3 h-3'
                data-testid='indeterminate-icon'
                width='12'
                height='12'
                viewBox='0 0 12 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2 6H10'
                  fill='none'
                  stroke='currentColor'
                  strokeLinecap='round'
                />
              </svg>
              )
            : (
              <svg
                aria-hidden
                className='h-3 w-3'
                data-testid='checked-icon'
                width='12'
                height='12'
                viewBox='0 0 12 12'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2 6L4.5 8.5L10 3'
                  stroke='currentColor'
                  fill='none'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              )}
        </div>
      </div>
    )
  }
)
